import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFirestore } from "angularfire2/firestore";
import { Observable } from "rxjs/Observable";
import { catchError } from "rxjs/operators";
import { IPoll, IPollQuestions } from "../shared/models/polls.model";
import { Utilities } from "./utilities";

@Injectable()
export class PollData {

  constructor(
    private afDb: AngularFireDatabase,
    private afStore: AngularFirestore,
    private http: HttpClient,
    private utilities: Utilities,
  ) { }

  public getPollsByClient(client: string): Observable<IPoll[]> {
    return this.afDb.list<IPoll>(`Clients/${client}/Polls`).
      valueChanges();
  }

  public getPollById(client: string, id: string): Observable<IPoll> {
    return this.afDb.object<IPoll>(`Clients/${client}/Polls/${id}`).
      valueChanges();
  }

  public createPoll(client: string, poll: IPoll) {
    if (poll.id === "") { poll.id = this.afDb.createPushId(); }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Polls/${poll.id}`)
        .update({ id: poll.id, general: poll })
        .then(() => {
          resolve(poll);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getQuestionByPollId(client: string, id: string, questionId: string): Observable<IPollQuestions> {
    return this.afDb.object<IPollQuestions>(`Clients/${client}/Polls/${id}/questions/${questionId}`).
      valueChanges();

  }

  public updateQuestionByPollId(client: string, id: string, question: IPollQuestions): Observable<any> {
    if (question.id === "") { question.id = this.afDb.createPushId(); }
    return Observable.fromPromise(
      this.afDb.object(`Clients/${client}/Polls/${id}/questions/${question.id}`)
        .update(question));
  }

  public getPollAnswers(clientId: string, pollId: string) {
    return this.afStore
      .collection(clientId)
      .doc("poll-answers")
      .collection(pollId)
      .valueChanges();
    // .map((data) => {
    //   return (isEmpty(data)) ? data : data[0];
    // });
  }

  public getPollEventAnswers(clientId: string, eventId: string, pollId: string) {
    return this.afStore
      .collection(clientId)
      .doc("poll-events")
      .collection(`${pollId}`)
      .doc("event")
      .collection(`${eventId}`)
      .valueChanges();
  }

  public getPollXls(clientId: string, pollId: string, eventId: string = null): Observable<any> {
    let endpoint = "";
    if (this.utilities.validateEventIdParam(eventId)) {
      endpoint = `${ENV.backend}/reports/polls/${clientId}/${eventId}/${pollId}`;
    } else {
      endpoint = `${ENV.backend}/reports/polls/${clientId}/${pollId}`;
    }

    return this.http.get(endpoint)
      .pipe(
        catchError((err) => {
          this.utilities.consoleDecorator("Error report generate: ", err, "orange");
          return err;
        }),
      );
  }


  public setVisibilityQuestion(clientId, pollId, questionId, value) {
    return this.afDb.object(`/Clients/${clientId}/Polls/${pollId}/questions/${questionId}`).update({
      isVisible: value,
    });
  }

  // public getJSONPoll(clientId: string, pollId: string, eventId: string = null) {
  //   let httpObs;
  //   if (this.utilities.validateEventIdParam(eventId)) {
  //     httpObs = this.http.get(`${ENV.backend}/util/polls/${clientId}/${eventId}/${pollId}`);
  //   } else {
  //     httpObs = this.http.get(`${ENV.backend}/util/polls/${clientId}/${pollId}`);
  //   }

  //   return httpObs;
  // }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/poll.ts